import { render, staticRenderFns } from "./RuleUseEditModal.vue?vue&type=template&id=28b3edd6"
import script from "./RuleUseEditModal.vue?vue&type=script&lang=js"
export * from "./RuleUseEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports